import {FC, ReactNode, useMemo} from "react";
import {useTranslation} from "react-i18next";
import {useSidebarItems} from "../navigation";
import {PageHeading, PageTemplate} from "../layout";
import {EmbeddedComponentLoader} from "./EmbeddedComponentLoader";
import {
  pageSummaryKeyFor,
  pageTitleKeyFor,
  SidebarComponent
} from "./SidebarComponent";

export interface SidebarComponentPageProps {
  component: SidebarComponent;
}

export const SidebarComponentPage: FC<SidebarComponentPageProps> = ({
  component
}) => {
  const {t} = useTranslation();
  const sidebarItems = useSidebarItems({page: component.id});
  const heading = useMemo<ReactNode | undefined>(() => {
    const title = t(pageTitleKeyFor(component), {defaultValue: ""});
    if (title) {
      const summary = t(pageSummaryKeyFor(component), {defaultValue: ""});
      return summary ? (
        <PageHeading title={title} summary={summary} />
      ) : (
        <PageHeading title={title} />
      );
    }
    return undefined;
  }, [component, t]);

  return (
    <PageTemplate
      id={`${component.id}-page`}
      title={t(pageTitleKeyFor(component), {defaultValue: ""})}
      banner={heading}
      sidebarItems={sidebarItems}>
      <EmbeddedComponentLoader component={component} />
    </PageTemplate>
  );
};
